module.exports = __webpack_public_path__ + "media/images/emblems/Oberwil_im_Simmental-coat_of_arms-2944103808efd30af8e95df971ee999f.svg";